import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "advanced-search-btn-content" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "advanced-search-btn-content" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: _normalizeClass(["basic-search", {
          'mb-3': _ctx.displayAdvancedSearch,
          'minimal-height': !_ctx.displayAdvancedSearch,
        }])
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "basic-search", {}, undefined, true),
            _createVNode(_component_v_btn, {
              id: "listFilters-btn-advancedSearch",
              class: "ma-0 advanced-search-btn",
              color: "secondary",
              disabled: _ctx.loading,
              onClick: _ctx.toggleAdvancedSearch
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.showAdvancedSearchDirtyIcon)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        top: ""
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({ color: "white" }, props), {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createTextVNode("mdi-information", -1)
                            ]))]),
                            _: 1
                          }, 16),
                          _createTextVNode(" " + _toDisplayString(_ctx.displayAdvancedSearch ? _ctx.$t("buttons.HIDE_ADVANCED_SEARCH") : _ctx.$t("buttons.SHOW_ADVANCED_SEARCH")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('messages.CONTAINS_ADVANCED_SEARCH')), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.displayAdvancedSearch ? _ctx.$t("buttons.HIDE_ADVANCED_SEARCH") : _ctx.$t("buttons.SHOW_ADVANCED_SEARCH")), 1))
                ])
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }),
    (_ctx.displayAdvancedSearch)
      ? (_openBlock(), _createBlock(_component_v_col, {
          key: 0,
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "advanced-search", {}, undefined, true)
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_col, {
      cols: "12",
      class: _normalizeClass(["text-center py-0 advanced-search-btn-mobile", { 'pt-3': _ctx.displayAdvancedSearch }])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          id: "listFilters-btn-advancedSearch",
          class: "ma-1",
          color: "secondary",
          disabled: _ctx.loading,
          onClick: _ctx.toggleAdvancedSearch
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.showAdvancedSearchDirtyIcon)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    top: ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_icon, _mergeProps({ color: "white" }, props), {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-information", -1)
                        ]))]),
                        _: 1
                      }, 16),
                      _createTextVNode(" " + _toDisplayString(_ctx.displayAdvancedSearch ? _ctx.$t("buttons.HIDE_ADVANCED_SEARCH") : _ctx.$t("buttons.SHOW_ADVANCED_SEARCH")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('messages.CONTAINS_ADVANCED_SEARCH')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.displayAdvancedSearch ? _ctx.$t("buttons.HIDE_ADVANCED_SEARCH") : _ctx.$t("buttons.SHOW_ADVANCED_SEARCH")), 1))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}